import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as CotplayHubActions from '../../../actions/CotplayHubActions';
import { Select, Input, Button } from 'antd';
import TextEvents from '../../../components/TextEvents';
import { Grid } from '@material-ui/core';

// Styles:
import { useStyles, styles } from '../CotplayHubContainerStyles';
import './CotplayHubSelectors.css';

const { Search } = Input;


export const CotplayHubSelectors = (props) => {

    const { Option } = Select;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [idTraining, setIdTraining] = useState(undefined);
    const [idSystemSpecialty, setIdSystemSpecialty] = useState(undefined);
    const [searchText, setSearchText] = useState([]);

    // States:
    const {
        employeeId
    } = useSelector(state => state.Auth.employeeById);

    const {
        trainingType,
        isLoadingTraining,
        systemSpecialty,
        isLoadingSystemSpecialty,
        pagination,
        isLoadingMedia,
        filtersListMedia
    } = useSelector(state => state.CotplayHubReducer);

    const RelatedToMyPosition = (model) => {
        var filter = { idTraining: undefined, idSystemSpecialty: undefined, employeeId: employeeId }
        setIdTraining(undefined);
        setIdSystemSpecialty(undefined);
        dispatch(CotplayHubActions.saveFilter(filter))
        dispatch(CotplayHubActions.trainingNamesMediaVideo());

        var obj =
        {
            employeeId: employeeId
            , isMostViewed: false
            , offset: 0
            , limit: pagination.pageSize
            , employeeId: employeeId
        }

        if (searchText.length > 0 && !model) {
            obj.IdCourse = searchText.join('|');
        }

        dispatch(CotplayHubActions.getMedia(obj))


        dispatch(CotplayHubActions.getMedFilters({
            employeeId: employeeId, isMostViewed: false, offset: 0, limit: 0
        }))

        props.setisMostViewed(false)
    }

    const MostViewed = (model) => {
        var filter = { idTraining: undefined, idSystemSpecialty: undefined, employeeId: employeeId }
        setIdTraining(undefined);
        setIdSystemSpecialty(undefined);
        dispatch(CotplayHubActions.saveFilter(filter))
        dispatch(CotplayHubActions.trainingNamesMediaVideo());

        var obj =
        {
            isMostViewed: true, offset: 0, limit: pagination.pageSize, employeeId: employeeId,
        }

        if (searchText.length > 0 && !model) {
            obj.IdCourse = searchText.join('|');
        }

        dispatch(CotplayHubActions.getMedia(obj))
        dispatch(CotplayHubActions.getMedFilters({
            employeeId: employeeId,
            offset: 0,
            limit: 0,
            isMostViewed: true,
        }))
        props.setisMostViewed(true)


    }

    const openTag = (item, model) => {
        if (!isLoadingMedia) {
            setIdTraining(item);
            setIdSystemSpecialty(undefined);
            var filter = { idTraining: item, idSystemSpecialty: undefined, employeeId: employeeId, }

            dispatch(CotplayHubActions.saveFilter(filter))
            dispatch(CotplayHubActions.specialtyMediaVideo({
                idTraining: item
                , employeeId: employeeId
            }));


            var obj =
            {
                isMostViewed: false,
                offset: 0,
                limit: pagination.pageSize,
                idTraining: item === undefined ? '' : item
                , employeeId: employeeId
            }

            if (searchText.length > 0 && !model) {
                obj.IdCourse = searchText.join('|');
            }

            dispatch(CotplayHubActions.getMedia(obj));
            dispatch(CotplayHubActions.getMedFilters({
                isMostViewed: false,
                offset: 0,
                limit: 0,
                idTraining: item === undefined ? '' : item
                , employeeId: employeeId,

            }))
        }
    }

    const openSubTag = (item, model) => {
        if (!isLoadingMedia) {
            setIdSystemSpecialty(item);
            var filter = { idTraining: idTraining, idSystemSpecialty: item, employeeId: employeeId }
            dispatch(CotplayHubActions.saveFilter(filter))

            var obj =
            {
                isMostViewed: false,
                offset: 0,
                limit: pagination.pageSize,
                idTraining: idTraining,
                IdSpecialtyOrSystem: item === undefined ? '' : item
                , employeeId: employeeId,
            }

            if (searchText.length > 0 && !model) {
                obj.IdCourse = searchText.join('|');
            }

            dispatch(CotplayHubActions.getMedia(obj))
            dispatch(CotplayHubActions.getMedFilters({
                isMostViewed: false,
                offset: 0,
                limit: 0,
                idTraining: idTraining,
                IdSpecialtyOrSystem: item === undefined ? '' : item
                , employeeId: employeeId,
            }))
        }
    }

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })

        if (i.length === 0) {
            setSearchText([])
        } else {
            setSearchText(value)
        }


    }

    const handleSearch = () => {
        if (!props.isMostViewed & idTraining === undefined) {
            RelatedToMyPosition();
        } else if (props.isMostViewed & idTraining === undefined) {
            MostViewed();
        } else {
            //idTraining
            openTag(idTraining)
        }
    }

    return (
        <>
            {/* <Search
                placeholder="Busqueda por texto..."
                onSearch={value => console.log(value)}
                style={{ width: 400 }}
            /> */}
            <TextEvents
                text='Busqueda por texto...'
                color="darker"
                size='label'
                weight="medium"
            />
            <Grid container direction="row">
                <Grid item xs={10}>
                    <Select
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={styles.inputSelect}
                        placeholder="Selecciona nombre"
                        onChange={(v, i) => handleChange(v, i, 'key')}
                        value={searchText}
                    >
                        {
                            filtersListMedia.map((item) => (
                                <Option key={item.idCourse}>{item.course}</Option>
                            ))
                        }
                    </Select>
                </Grid>
                <Grid item xs={2}>
                    <Button type="link" shape="circle" icon="search" onClick={() => { handleSearch() }} disabled={searchText.length === 0} />
                </Grid>
            </Grid>


            {/*Selection Buttons */}

            <div className='TagBox'>
                <button
                    className={!props.isMostViewed & idTraining === undefined & searchText.length === 0 ? 'TagActive' : 'Tag'}
                    onClick={() => {
                        setSearchText([]);
                        RelatedToMyPosition(true);
                    }}
                >
                    Mi Puesto
                </button>

                <button
                    className={props.isMostViewed & idTraining === undefined ? 'TagActive' : 'Tag'}
                    onClick={() => {
                        setSearchText([]);
                        MostViewed(true);
                    }}
                >
                    Más Vistos
                </button>

                {
                    trainingType.map((item) =>
                        <button
                            className={idTraining === item.key ? 'TagSecondaryActive' : isLoadingMedia ? 'TagSecondaryDisabled' : 'TagSecondary'}
                            onClick={() => { setSearchText([]); openTag(item.key, true); }}
                            value={item.value}
                            key={item.key}
                        >
                            {item.value}
                        </button>
                    )
                }

            </div>

            <div className='TagBox'>
                {
                    idTraining !== undefined ?
                        systemSpecialty.map((item) =>
                            <button
                                className={idSystemSpecialty === item.key ? 'TagSelectionActiveSpec' : isLoadingMedia ? 'TagSelectionDisabled' : 'TagSelection'}
                                onClick={() => { setSearchText([]); openSubTag(item.key, true) }}
                                value={item.value}
                                key={item.key}
                            >
                                {item.value}
                            </button>
                        ) : []
                }
            </div>


        </>
    )

}


